
import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './style.css';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';

const ContactUs = () => {
    const [isCompany, setIsCompany] = useState(false);
    const [formStatus, setFormStatus] = useState('');
    const form = useRef();

    const handleContactTypeChange = (e) => {
        setIsCompany(e.target.value === 'company');
    };

    const sendEmail = (e) => {
        e.preventDefault(); // Prevent the default form submission behavior

        emailjs.sendForm(
            'service_02vx4j8', 
            'template_iryau21', 
            form.current, 
            'DJTsvjgQsAT7GDqPR'
        ).then(
            () => {
                console.log('SUCCESS!');
                setFormStatus('SUCCESS'); 
            },
            (error) => {
                console.log('FAILED...', error.text);
                setFormStatus('FAILED');  
            }
        );
    };

    return (
        <>
            <Header />
            <div>
                <h2 className="pos-heading">Contact Us</h2>
            </div>
            <div className="contact1-container">
                <div className="contact1-form">
                    <form ref={form} onSubmit={sendEmail}>
                        <input className="" type="text" name="user_name" placeholder="Name" required />
                        <input type="email" name="user_email" placeholder="Email" required />
                        <input type="tel" name="contact_number" placeholder="Contact Number" required />
                        <input type="text" name="city" placeholder="City" required />

                        <div className='d-flex flex-row gap-5'>
                            <select name="contact_type" onChange={handleContactTypeChange} required>
                                <option selected value="">Type</option>
                     c           <option value="individual">Individual</option>
                                <option value="company">Company</option>
                            </select>

                            {isCompany && (
                                <input type="text" name="company_name" placeholder="Company Name" required />
                            )}

                            <select name="reason" required>
                                <option selected value="">Reason</option>
                                <option value="software">Software Inquiry</option>
                                <option value="product">Know About Product</option>
                                <option value="payment">Payment Issue</option>
                                <option value="support">Customer Support</option>
                                <option value="other">Other</option>
                            </select>
                        </div>

                        <textarea name="message" placeholder="Message" required></textarea>

                        {/* Button that submits the form and triggers sendEmail */}
                        <div>
                        {formStatus === 'SUCCESS' && <p className="success-message">Submitted successfully! We'll get back to you soon.</p>}
                        {formStatus === 'FAILED' && <p className="error-message">Failed to submit, please try again later.</p>}
                        </div>
                        <button className='contact1-form-btn' type="submit">Submit</button>
                    </form>
                </div>

                <div className="contact1-info">
                    <p>📧 gsk@gsktechnology.com</p>
                    <p>📞 (65) 91934818</p>
                    <p>📍 5 Soon Lee Street, Pioneer Point, #02-55
                        Singapore 627607</p>
                    <p>⏰ 08:00 - 18:00</p>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default ContactUs;
